export const financialData = [
  {
    id: 'f-1',
    title: 'Term Life Insurance',
    subtitle: 'Get Rs 1 crore cover in just 3 minutes!',
    text: "Secure your Family's future with our award winning life cover also get optional cover against 34 Critical illness and Accidental death.",
  },
  {
    id: 'f-2',
    title: 'PayLater',
    subtitle: 'Purchase now and',
    text: 'Get up to 45 days zero interest digital credit with just a click. Pay bills, shop online and make payment to any merchant UPI ID instantly',
  },
  {
    id: 'f-3',
    title: 'National Pension System',
    subtitle: 'Retirement planning and Tax Benefits',
    text: 'EEE status of NPS gives you tax benefits at contribution, corpus at withdrawal and monthly pension',
  },
  {
    id: 'f-4',
    title: 'Insta SIP',
    subtitle: "Fulfil life's goals with",
    text: 'Start building a corpus of Rs. 1 Crore by investing just Rs. 7734 per month. Benefit from power of compounding returns and paperless process',
  },
  {
    id: 'f-5',
    title: 'Your life & money',
    subtitle: 'Safety always comes first for',
    text: ' Ensure the safety of your hard earned money with the security & safety of Palasio Bank Fixed Deposit',
  },
];

export const accounts = [
  {
    id: 'a-1',
    title: 'Seniors Club Savings Account',
    benefits: [
      'Higher interest rate on account balance',
      'Secured returns and tax-saving benefits',
      'Hospitalisation allowance up to ₹ 30,000',
    ],
  },
  {
    id: 'a-2',
    title: 'Insta Save Account',
    benefits: [
      'Exciting offers on your favourite brands',
      'Earn reward points when you shop with Platinum Visa Debit Card',
      'Complimentary air accident insurance worth ₹50,000',
    ],
  },
  {
    id: 'a-3',
    title: "'The ONE' Savings Account",
    benefits: [
      'Exclusive life insurance and health insurance offers',
      'Subscription to premium services such as Amazon Prime and Zomato Pro',
      'Waiver of brokerage on equity investments up to ₹22,500',
    ],
  },
];

export const debitCards = [
  {
    id: 'd-1',
    title: 'Sapphiro Debit Card',
    benefits: [
      'Get annual savings up to Rs.30,000/-* on usage of your debit card',
      'Complimentary airport lounge access',
      '4 points per Rs 200 spent on domestic and 8 points on international transaction.',
    ],
  },
  {
    id: 'd-2',
    title: 'Rubyx Debit Card',
    benefits: [
      'Get annual savings up to Rs.20,000/-* on usage of your debit card',
      'Card Protection Plan, courtesy OneAssist',
      '3 points per Rs 200 spent on domestic and 6 points on international transaction.',
    ],
  },
  {
    id: 'd-3',
    title: 'Coral Debit Card',
    benefits: [
      'Get annual savings up to Rs.10,000/-* on usage of your debit card',
      'Get executive health check-up worth Rs 3,600 for just Rs 1,300',
      '2 points per Rs 200 spent on domestic and 4 points on international transaction.',
    ],
  },
];

export const creditCards = [
  {
    id: 'c-1',
    title: 'Mine Credit Card',
    benefits: [
      '1% cashback on all retail spends',
      'Fuel surcharge waiver on all HPCL pumps',
      'Cashback capped at Rs 100 per month.',
    ],
  },
  {
    id: 'c-2',
    title: 'HPCL Coral Credit Card',
    benefits: [
      'Earn 6 PAYBACK Points from ICICI Bank Rewards Points per ₹ 100 spent on fuel at HPCL',
      'Redeem 2,000 PAYBACK Points from ICICI Bank Rewards Points for fuel worth ₹ 500',
      '2.5% cashback & zero surcharge on fuel purchase at HPCL',
    ],
  },
  {
    id: 'c-3',
    title: 'MakeMyTrip Credit Card',
    benefits: [
      'Get exclusive MMT Cabs benefit and a complimentary Airtel international roaming pack',
      'Enjoy complimentary domestic airport# and domestic railway lounge access',
      'Get Rs 500 My Cash plus MakeMyTrip holiday voucher worth Rs 3,000 on joining',
    ],
  },
];
